import { UserFeedback as BaseUserFeedback } from '@leroy-merlin-br/backpack-user-feedback'

import { useUserResources } from 'scripts/react-components/shared/hooks'

export default function UserFeedback() {
  const { userResources, userControls } = useUserResources()

  const email = userResources?.email || ''
  const isOnAssistedSale = Boolean(userControls.isAssistedSale)

  return <BaseUserFeedback user={{ email, isOnAssistedSale }} />
}
